import getUnnormalizedCategory from '~/utils/getUnnormalizedCategory';

const toTitleCase = (str: string): string => {
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const formatTagDisplayName = (tag: string): string => {
  const decoded = getUnnormalizedCategory(tag);

  if (!decoded) {
    return '';
  }

  if (decoded.includes('-') && !decoded.includes(' ')) {
    const withSpaces = decoded.replace(/-/g, ' ');
    return toTitleCase(withSpaces);
  }

  return decoded;
};

export default formatTagDisplayName;
